import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class SearchBox extends Component {
	constructor(props) {
		super(props);

		this.inputKeyPressHandler = this.inputKeyPressHandler.bind(this);
		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.executeSearch = this.executeSearch.bind(this);

		this.state = {
			searchBoxInput: ''
		};
	}

	inputKeyPressHandler(event) {
		if (event.key == 'Enter') {
			this.executeSearch();
		}
	}

	inputChangeHandler(event) {
		var stateObj = {};

		stateObj[event.target.name] = event.target.value;

		this.setState(stateObj);

		this.refs.searchInput.focus();
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.setState({
				searchBoxInput: this.props.searchString
			});
		}

		this.refs.searchInput.focus();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.searchString != prevProps.searchString) {
			this.setState({
				searchBoxInput: this.props.searchString
			});
		}
	}

	executeSearch() {
		this.props.history.push('/fraedimenn/'+this.state.searchBoxInput);
	}

	render() {
		return (
			<div className="webform-submission-form">

				<div className="form-item js-form-item c-form-element js-form-element c-form-element--type-textfield js-form-element--type-textfield c-form-element--nafn js-form-element--nafn">
					<label for="fr-skra-search" className="c-label js-label--required">Leitarorð, nafn, land eða staða</label>
					<input ref="searchInput"
						id="fr-skra-search" 
						name="searchBoxInput"
						className="form-text required c-input"
						placeholder="Leit í fræðimannaskrá"
						type="text"
						value={this.state.searchBoxInput}
						onKeyPress={this.inputKeyPressHandler} 
						onChange={this.inputChangeHandler}
					/>
				</div>
				
				<div class="form-actions">
					<input class="webform-button--submit button button--primary js-form-submit form-submit c-button" 
						onClick={this.executeSearch.bind(this)}
						data-drupal-selector="edit-actions-submit" 
						type="submit" value="Leita" />
				</div>

			</div>
		);
	}
}

export default withRouter(SearchBox);
